/**
 * 建议不引入其他
 */
function loadCssCode(code){
  var style = document.createElement('style');
  style.type = 'text/css';
  style.rel = 'stylesheet';
  //for Chrome Firefox Opera Safari
  style.appendChild(document.createTextNode(code));
  //for IE
  //style.styleSheet.cssText = code;
  var head = document.getElementsByTagName('head')[0];
  head.appendChild(style);
}

function loadFavico(ico){
  var favico = document.createElement('link');
  favico.type = 'image/x-icon';
  favico.rel = 'shortcut icon';
  favico.href = ico;
  var head = document.getElementsByTagName('head')[0];
  head.appendChild(favico);
}


var SKIN = {
  lib : [],
  mulit : true,
  set:function({ skinLib = [] , auto=true , mulit = true  }){
    SKIN.lib = skinLib;

    this.mulit = !!mulit;
    auto && (this.auto());


  },
  auto:function(){
    //先匹配链接上的key
    var urlSearch1 = window.location.search;
    var urlSearch2 = urlSearch1.split("?").pop();
    if(urlSearch2){
      var urlSearch3 = urlSearch2.split("&");
      console.log(Array.isArray(urlSearch3));
      console.log(urlSearch3.find);
      var urlSearch4 = urlSearch3.find(item => item.toLowerCase().indexOf("key=") === 0);
      if(urlSearch4){
        var lastKey = urlSearch4.split("=").pop();
        if(lastKey && this.load("key",lastKey)){
          if(!this.mulit){return ;}
        }
      }
    }

    //无则匹配域名
    var hostname = window.location.hostname;
    if(hostname.indexOf("www.")===0){
      hostname = hostname.replace("www.","");
    }
    if(this.load("host",hostname)){
      if(!this.mulit){return ;}
    }

    //最后才匹配端口
    var portNum = window.location.port;
    if(this.load("port",portNum)){
      if(!this.mulit){return ;}
    }


    //在此释放资源
    this.lib.forEach(d=>{
      delete d.content;
    })
  },
  load:function(type,value){
    if(typeof this.lib === 'object'){
      var results1 = SKIN.lib.filter(l => l.type == type);
      var hasOf = false;
      if(results1){
        for(var i=0,l=results1.length;i<l;i++){
          if(results1[i].list.indexOf(value)>-1){
            loadCssCode(results1[i].content);
            hasOf = true;

            if(typeof results1[i].favicos == 'object'){
              for(var key in results1[i].favicos){
                if(key == value){
                  loadFavico(results1[i].favicos[key]);
                }
              }
            }else if(results1[i].favicos){
              loadFavico(results1[i].favicos)
            }


            if(!this.mulit){
              //释放资源
              this.lib.forEach(d=>{
                delete d.content;
              })
            }

            //return true;
          }
        }
      }
    }
    if(hasOf){return true;}
    return false;
  }
}


export default SKIN;



// WEBPACK FOOTER //
// ./../../plugins/skin.js